import WysiwygContent from './WysiwygContent.client'
export default WysiwygContent
